import { POSA_FORMAT } from "../lottery/POSAType";

export default interface UploadedPOSA {
  _id: string;
  trackingID: string;
  ts: number;
  type: string;
  status: Status;
  inputImage: POSAFile;
  outputImage?: POSAFile;
  placeName: string;
  comments?: Comment[];
}

export enum Status {
  CREATED = "Created",
  IN_PROGRESS = "InProgress",
  PENDING_AM = "PendingAM", // Account Manager
  PENDING_CLIENT = "PendingClient",
  RESENT = "Resent",
  REJECTED_BY_TEAM = "RejectedByTeam",
  DONE = "Done",
}

interface POSAFile {
  name: string;
}

interface Comment {
  comment: string;
  ts: number;
  isInternal: boolean;
}

export type POSAOptionType = {
  format: POSA_FORMAT | "none";
  displayName: string;
  isUpload?: boolean;
};
